import axios from 'axios';
import {
  BASE_URL,
  DATE_FILTER,
  PAGINATION,
  REPORT_URL,
  RESTAURANT_ID_FILTER,
  SEARCH,
  USER_ID_FILTER,
} from './Urls';

export class ReportApiModule {
  async getAllReports(paramInfo) {
    try {
      const response = await axios.get(
        BASE_URL +
          PAGINATION(REPORT_URL, paramInfo.pageNo, paramInfo.pageSize) +
          SEARCH(paramInfo?.searchKeyword) +
          RESTAURANT_ID_FILTER(paramInfo?.restaurantIdFilter) +
          USER_ID_FILTER(paramInfo?.userIdFilter) +
          DATE_FILTER(paramInfo?.startDate, paramInfo?.endDate)
      );
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data || [],
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: [],
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: [],
        message: error.response.data.message || error.message,
      };
    }
  }
}
